import { bootstrapApplication } from '@angular/platform-browser';
import { isDevMode } from '@angular/core';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import * as Sentry from '@sentry/angular';
import { buildSentryOptions } from './app/core/sentry/sentry-options';

if (!isDevMode()) {
  Sentry.init(buildSentryOptions());
}

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
